import React, { useEffect, useState, useRef } from "react";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaUser,
  FaArrowLeftLong,
} from "react-icons/fa6";
import { MdDelete, MdClose } from "react-icons/md";
import { handleRowsPerPage } from "../../../controls/Pagination/Pagination";
import { history } from "../../../../store/configure/configureStore";
import { youtubeUrlConstants } from "../../../../store/YouTubeManagement/YouTubeManagementReducer";
import moment from "moment";
import YouTube from "react-youtube";
// import queryString from "query-string";

import { Header, DataTable } from "../../../common";
import {
  ButtonView,
  CardView,
  Input,
  Select,
  TagView,
  ModalView,
} from "../../../controls";
import { Role } from "../../../../constants/role";
//
import "./MobileUserActivityDetailsStyles.scss";

const MobileUserActivityDetailsView = ({
  mobileUserActivityLogById,
  onClickCancel,
}) => {
  console.log("activity", mobileUserActivityLogById);

  const { requestMethod, requestUrl, requestBody, requestResponse } =
    mobileUserActivityLogById;

  const getMethodColor = (method) => {
    switch (method?.toLowerCase()) {
      case "get":
        return "#4CAF50"; // A vibrant green for "GET" requests
      case "post":
        return "#FF9800"; // A bold orange for "POST" requests
      case "put":
        return "#2196F3"; // A bright blue for "PUT" requests
      case "delete":
        return "#F44336"; // A striking red for "DELETE" requests
      case "patch":
        return "#9C27B0"; // A purple shade for "PATCH" requests
      default:
        return "#9E9E9E"; // A neutral gray for other methods or unknown ones
    }
  };

  const renderDetailRow = (label, value) => (
    <div className="row-wrapper">
      <span className="label-wrapper">{label}</span>
      <span className="partition">:</span>
      <span className="value">{value || "N/A"}</span>
    </div>
  );

  const urlWithMethod = (
    <span
      className="method-tag"
      style={{ color: getMethodColor(requestMethod) }}
    >
      requestMethod
    </span>
  );

  // const renderURLDetails = () => {
  //   return (
  //     <div className="primary-block">
  //       {renderDetailRow("Request", urlWithMethod + requestUrl || "N/A")}
  //     </div>
  //   );
  // };

  const renderURLDetails = () => {
    const urlWithMethod = (
      <div className="wrapper">
        <span
          className="method-tag"
          style={{ color: getMethodColor(requestMethod) }}
        >
          {requestMethod?.toUpperCase()}
        </span>
        <span style={{ margin: "0 5px" }}>{requestUrl || "N/A"}</span>
      </div>
    );

    return (
      <div className="primary-block">
        {renderDetailRow("Request", urlWithMethod)}
      </div>
    );
  };

  const renderRequestDetails = () => {
    return (
      <div className="request-block">
        <div className="block-title">Request Body</div>
        <pre className="preserve-tag">
          {JSON?.stringify(requestBody, null, 2)}
        </pre>
      </div>
    );
  };

  const renderResponseDetails = () => {
    return (
      <div className="request-block">
        <div className="block-title">Response Body</div>
        <pre className="preserve-tag">
          {JSON?.stringify(requestResponse, null, 2)}
        </pre>
      </div>
    );
  };

  const renderDetails = () => {
    return (
      <div className="details-block">
        {renderURLDetails()}
        <div className="body-block">
          {renderRequestDetails()}
          {renderResponseDetails()}
        </div>
      </div>
    );
  };

  return (
    <div className="mobile__user__activity__details--container">
      <div className="mobile__user__activity__details--header-wrapper">
        <div className="action">
          <FaArrowLeftLong size={25} onClick={onClickCancel} />
        </div>
        <div className="title-content">Activity Log Details</div>
        {/* <div className="action-btn-wrapper">
          <ButtonView
            title="Cancel"
            styles={"secondary"}
            // icon={<FaPlus />}
            onClick={onClickCancel}
          />
        </div> */}
      </div>
      <div className="mobile__user__activity__details--content-details-wrapper">
        {renderDetails()}
      </div>
    </div>
  );
};

export default MobileUserActivityDetailsView;
